import { EventEmitter } from "events";
export const eventEmitter = new EventEmitter();


// WEBPACK FOOTER //
// ./src/connects/eventEmitter.js